import { type ValueOf } from '@direct-frontend/stdlib';
import { ONBOARDING_LITE_STEPS, ONBOARDING_LITE_SUBTASKS } from '#shared/api/onboarding';
import { SCROLL_TO_ELEMENTS_MAP } from '#shared/lib/hocs';
import {
    SETTINGS_LOGISTICS_SEARCH_PARAMS_SERVICES,
    settingsAboutRoute,
    settingsIntegrationsRoute,
    settingsInventoryRoute,
    settingsLogisticsRoute,
    settingsPaymentRoute,
    settingsTestOrderRoute,
} from '#shared/lib/routes';
import { type OnboardingStepProps, type OnboardingSubtaskProps } from '../lib/types';

export const liteStepsProps: Record<ValueOf<typeof ONBOARDING_LITE_STEPS>, OnboardingStepProps> = {
    [ONBOARDING_LITE_STEPS.ADD_PRODUCTS]: {
        name: 'Добавьте товары',
        href: settingsInventoryRoute.getUrl(),
        description: 'Добавьте товары, цены и остатки. Вы можете использовать один или несколько источников данных',
    },
    [ONBOARDING_LITE_STEPS.SPECIFY_COMPANY_INFORMATION]: {
        name: 'Укажите информацию о компании',
        href: settingsAboutRoute.getUrl(),
        description: 'Проверьте ИНН и ссылки на необходимые страницы',
    },
    [ONBOARDING_LITE_STEPS.CONNECT_DELIVERY_AND_PAYMENT]: {
        name: 'Подключите доставку, оплату и онлайн-кассу',
        href: settingsLogisticsRoute.getUrl({ searchParams: SETTINGS_LOGISTICS_SEARCH_PARAMS_SERVICES }),
        description: 'Подключение доставки и оплаты может занимать до 7 дней',
    },
    [ONBOARDING_LITE_STEPS.CONNECT_METRIKA]: {
        name: 'Подключите Яндекс Метрику',
        href: settingsIntegrationsRoute.getUrl(),
        description: 'Помогает изучать поведение пользователей при совершении заказов',
    },
    [ONBOARDING_LITE_STEPS.MAKE_TEST_ORDER]: {
        name: 'Сделайте тестовый заказ',
        href: settingsTestOrderRoute.getUrl(),
        description: 'Тестовый заказ необходим для проверки работоспособности систем оплаты и передачи в доставку',
    },
    [ONBOARDING_LITE_STEPS.PUBLISH]: {
        name: 'Опубликовать',
    },
};

export const liteSubtasksProps: Record<ValueOf<typeof ONBOARDING_LITE_SUBTASKS>, OnboardingSubtaskProps> = {
    [ONBOARDING_LITE_SUBTASKS.FILL_COMPANY_INFO]: {
        name: 'Проверить ИНН, добавить логотип и иконку компании',
        href: settingsAboutRoute.getUrl(),
        orderWithinStage: 0,
    },
    [ONBOARDING_LITE_SUBTASKS.FILL_NECESSARY_PAGES]: {
        name: 'Заполнить содержание для необходимых страниц',
        href: settingsAboutRoute.getUrl(),
        hash: SCROLL_TO_ELEMENTS_MAP.settingsAboutRequiredPages,
        orderWithinStage: 1,
    },
    [ONBOARDING_LITE_SUBTASKS.CONNECT_DELIVERY]: {
        name: 'Подключить доставку',
        href: settingsLogisticsRoute.getUrl({ searchParams: SETTINGS_LOGISTICS_SEARCH_PARAMS_SERVICES }),
        orderWithinStage: 0,
    },
    [ONBOARDING_LITE_SUBTASKS.CONNECT_PAYMENT]: {
        name: 'Подключить оплату и онлайн-кассу',
        href: settingsPaymentRoute.getUrl(),
        orderWithinStage: 1,
    },
};
